// TODO: that's only snapshot related util. Should be placed somewhere in _/features/snapshots/snapshotPage
import { SnapshotStatus } from '_/features/snapshots/common/snapshot.constants';
import dayjs from 'dayjs';

export interface SnapshotOptions {
  time: 'hour';
  pendingQATime: number;
  qaTime: number;
}

// If a snapshot has been in PENDING_QA for 1 hour or more
// or has been in QA for 3 hours or more
// the row should be a color that indicates it needs attention.
export function snapshotNeedsAttention(status: string, date: number | string = Date.now(), options: SnapshotOptions): boolean {
  const dateDiff = dayjs(Date.now()).diff(date, options.time);

  if (
    (status === SnapshotStatus.PENDING_QA && dateDiff > options.pendingQATime) ||
    (status === SnapshotStatus.QA && dateDiff > options.qaTime)
  ) {
    return true;
  } else {
    return false;
  }
}
